
angular.module('tf.directives')

    .directive('datepicker', function() {
    return {
        restrict: 'E',
        templateUrl: "js/components/datepicker/datepicker.html",
        replace: true,
        scope: {
            date: '='
        },
        link : function(scope, element){
            element.datetimepicker();
        }

    };
});